export default {
  /* Banner列表 */
  queryBannerPageapi: '/deviceApi/deviceApi/banner/queryBannerPage',
  /* 新增Banner */
  addBannerapi: '/deviceApi/deviceApi/banner/addBanner',
  /* 修改Banner */
  editBannerapi: '/deviceApi/deviceApi/banner/editBanner',
  /* 品牌列表 */
  queryBrandPageapi: '/deviceApi/deviceApi/brand/queryBrandPage',
  /* 新增品牌 */
  addBrandapi: '/deviceApi/deviceApi/brand/addBrand',
  /* 修改品牌 */
  editBrandapi: '/deviceApi/deviceApi/brand/editBrand',
  /* 分页查询apk发布包 */
  queryAapkInfoReleasePageapi: '/deviceApi/deviceApi/apkInfoRelease/queryAapkInfoReleasePage',
  /* apk列表 */
  queryByQuerysearchapi: '/deviceApi/deviceApi/apkInfo/queryByQuerysearch',
  /* apk下拉列表 */
  queryByApkNameAllapi: '/deviceApi/deviceApi/apkInfo/queryByApkNameAll',
  /* 应用分类列表 */
  queryClassifyPageapi: '/deviceApi/deviceApi/classify/queryClassifyPage',
  /* 获取所有分类列表 */
  queryClassifyAllapi: '/deviceApi/deviceApi/classify/queryClassifyAll',
  /* 新增分类 */
  addClassifyapi: '/deviceApi/deviceApi/classify/addClassify',
  /* 编辑分类 */
  updateClassifyapi: '/deviceApi/deviceApi/classify/updateClassify',
  /* apk来源列表 */
  queryBySourcePageapi: '/deviceApi/deviceApi/apkSource/queryBySourcePage',
  /* 新增apk来源 */
  addApkSourceapi: '/deviceApi/deviceApi/apkSource/addApkSource',
  /* 编辑apk来源 */
  updateApkSourceapi: '/deviceApi/deviceApi/apkSource/updateApkSource',
  /* apk应用版本发布 */
  updateByApkStatusapi: '/deviceApi/deviceApi/apkInfoRelease/updateByApkStatus',
  /* apk应用版本上下架操作 */
  updateByApkStatusSoldapi: '/deviceApi/deviceApi/apkInfoRelease/updateByApkStatusSold',
  /* 精选专区分页展示 */
  queryPrefecturePageapi: '/deviceApi/deviceApi/prefecture/queryPrefecturePage',
  /* 新增精选专区 */
  addPrefectureapi: '/deviceApi/deviceApi/prefecture/addPrefecture',
  /* 查询所有专区 */
  queryPrefectureAllapi: '/deviceApi/deviceApi/prefecture/queryPrefectureAll',
  /* 编辑精选专区 */
  updatePrefectureapi: '/deviceApi/deviceApi/prefecture/updatePrefecture',
  /* 应用分类分页查询 */
  queryClassifyApkPageapi: '/deviceApi/deviceApi/classifyapk/queryClassifyApkPage',
  /* 添加应用分类 */
  addClassifyApkapi: '/deviceApi/deviceApi/classifyapk/addClassifyApk',
  /* 编辑应用分类 */
  updateClassifyApkapi: '/deviceApi/deviceApi/classifyapk/updateClassifyApk',
  /* 分页推荐专区 */
  queryApkSelectionPageapi: '/deviceApi/deviceApi/apkSelection/queryApkSelectionPage',
  /* 新增推荐专区 */
  addApkSelectionpi: '/deviceApi/deviceApi/apkSelection/addApkSelection',
  /* 新增推荐专区 */
  updateApkSelectionpi: '/deviceApi/deviceApi/apkSelection/updateApkSelection',
  /* 新增更多推荐 */
  addHotRecommendapi: '/deviceApi/deviceApi/hotRecommend/addHotRecommend',
  /* 更多推荐分页查询 */
  queryHotRecommendPageapi: '/deviceApi/deviceApi/hotRecommend/queryHotRecommendPage',
  /* 分页插叙搜索词记录 */
  querySearchRecordPageapi: '/deviceApi/deviceApi/statistics/querySearchRecordPage',
  /* 分页查询搜索词*/
  queryHotSearchPageapi: '/deviceApi/deviceApi/statistics/queryHotSearchPage',
  /* 添加搜索词*/
  addHotSearchapi: '/deviceApi/deviceApi/statistics/addHotSearch',
  /* 编辑搜索词*/
  updateHotSearchapi: '/deviceApi/deviceApi/statistics/updateHotSearch',
  /* 分页查询*/
  queryApkChannelPageapi: '/deviceApi/deviceApi/apkChannel/queryApkChannelPage',
  /* 新增过滤机型*/
  addApkChannelapi: '/deviceApi/deviceApi/apkChannel/addApkChannel',
  /* 删除过滤机型*/
  delApkChannelByIdapi: '/deviceApi/deviceApi/apkChannel/delApkChannelById',
  /*  根据分类ID查询子分类 */
  queryClassifypIdapi: '/deviceApi/deviceApi/classify/queryClassifypId',
  /* 应用来源获取 */
  queryApkSourceAllapi: '/deviceApi/deviceApi/apkSource/queryApkSourceAll',
  /* 应用信息编辑 */
  editApkInfoapi: '/deviceApi/deviceApi/apkInfo/editApkInfo',
  /* 首页应用是否展示*/
  updateHomeStatusapi: '/deviceApi/deviceApi/classifyapk/updateHomeStatus',
  /* 编辑应用图片*/
  editimagesapi: '/deviceApi/deviceApi/apkInfo/editimages',
  /* 获取所有品牌*/
  queryBrandAllapi: '/deviceApi/deviceApi/brand/queryBrandAll',
  /* 新增品牌应用分类*/
  savaBrandApkapi: '/deviceApi/deviceApi/brandApk/savaBrandApk',
  /* 编辑品牌应用分类*/
  editBrandApkapi: '/deviceApi/deviceApi/brandApk/editBrandApk',
  /* 品牌应用分类列表*/
  queryBrandApkByQueryapi: '/deviceApi/deviceApi/brandApk/queryBrandApkByQuery',
  /* mode管理*/
  querySysmodePageapi: '/deviceApi/deviceApi/sysmode/querySysmodePage',
  /* 新增mode*/
  sevaSysmodeapi: '/deviceApi/deviceApi/sysmode/sevaSysmode',
  /* 查询所有mode*/
  querySysModeAllapi: '/deviceApi/deviceApi/sysmode/querySysModeAll',
  /* 新增modeapk*/
  saveSysmodeApkapi: '/deviceApi/deviceApi/sysmodeApk/saveSysmodeApk',
  //相框数据统计
  getPhotoDayAddapi:'/photoApi/photo/api/getPhotoDayAdd',
  //相框数据统计
  getPhotoCountapi:'/photoApi/photo/api/getPhotoCount',
  //相框数据统计
  getPhotoActiveapi:'/photoApi/photo/api/getPhotoActive',
  // 指定设备
  updateDeviceListById: '/deviceApi/deviceApi/apkInfo/updateDeviceListById',
  // 根据id删除版本
  deleteApkInfoReleaseByIdApi: '/deviceApi/deviceApi/apkInfoRelease/deleteApkInfoReleaseById',
  // 根据id删除推荐专区
  deleteApkSelectionByIdByIdApi: '/deviceApi/deviceApi/apkSelection/deleteApkSelectionById',
  // 根据id删除应用分类
  deleteClassifyApkByIdApi: '/deviceApi/deviceApi/classifyapk/deleteClassifyApkById',
  // 根据id删除应用
  deleteApkInfoByIdApi: '/deviceApi/deviceApi/apkInfo/deleteApkInfoById',
  // 模块列表
  selectModuleTypeApi: '/deviceApi/deviceApi/moduleType/selectModuleType'

}



// WEBPACK FOOTER //
// ./src/api/baby/device.js